// App.js
import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import MainScreen from "./MainScreen";
import "./App.css";

function App() {
  const [messages, setMessages] = useState([]);
  const [conversations, setConversations] = useState([
    { id: 1, title: "Web tabanlı pdf sohbet", messages: [] }
  ]);
  const [activeConvId, setActiveConvId] = useState(1);
  const [theme, setTheme] = useState("light");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth > 768);
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState(0); // MainScreen’i sıfırlamak için

  // Yeni: convId resetleme tetikleyicisi
  const [resetConvIdTrigger, setResetConvIdTrigger] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSendMessage = (msg) => {
    setMessages((prev) => [...prev, msg]);
  };

  const handleThemeToggle = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const handleFileUpload = () => {
    setLoading(true);
    setTimeout(() => {
      setFileUploaded(true);
      setLoading(false);
    }, 1500);
  };

  const handleNewChat = () => {
    const newId = conversations.length + 1;
    const newConv = { id: newId, title: `Yeni sohbet ${newId}`, messages: [] };

    setMessages([]);
    setFileUploaded(false); // PDF yükleme ekranına dönsün
    setConversations([...conversations, newConv]);
    setActiveConvId(newId);
    setResetToken((t) => t + 1);       // MainScreen içindeki convId’yi sıfırla
    if (window.innerWidth <= 768) {    // mobilde sidebar’ı kapat
      setSidebarVisible(false);
    }

    // convId sıfırlansın
    setResetConvIdTrigger(prev => !prev);
  };

  return (
    <div className={`app-container ${theme}`}>
      <div className="menu-toggle" onClick={() => setSidebarVisible(!sidebarVisible)}>
        ☰
      </div>
      {sidebarVisible && (
        <Sidebar
          conversations={conversations}
          setActiveConvId={setActiveConvId}
          activeConvId={activeConvId}
          theme={theme}
          onThemeToggle={handleThemeToggle}
          onNewChat={handleNewChat}
        />
      )}
      <MainScreen
        messages={messages}
        onSendMessage={handleSendMessage}
        theme={theme}
        fileUploaded={fileUploaded}
        onFileUpload={handleFileUpload}
        loading={loading}
        resetToken={resetToken}
        resetConvIdTrigger={resetConvIdTrigger} // yeni prop
      />
    </div>
  );
}

export default App;
